export function changeTheme(skinName, animate) {
    if (true)//Theme choose disabled, temprarly
        return;
    if (!skinName)
        skinName = currentTheme();
    window.localStorage.setItem("nama-k-theme", skinName);
    $("#theme-main").attr("ref", `assets/base/kendo-ui/styles/kendo.${skinName}.min.css`);
    $("#theme-mobile").attr("ref", `assets/base/kendo-ui/styles/kendo.${skinName}.mobile.min.css`);

    let doc = document,
        kendoLinks = $("link[href*='kendo.']"),
        commonLink = kendoLinks.filter("[href*='kendo.common']"),
        skinLink = kendoLinks.filter(":not([href*='kendo.common'])"),
        href = location.href,
        skinRegex = /kendo\.\w+(\.min)?\.css/i,
        extension = skinLink.attr("rel") === "stylesheet" ? ".css" : ".less",
        newSkinUrl = skinLink.attr("href").replace(skinRegex, "kendo." + skinName + "$1" + extension);

    $("html").attr("class", "k-webkit k-webkit61");

    function preloadStylesheet(file, callback) {
        let element = $("<link rel='stylesheet' href='" + file + "' \/>").appendTo("head");

        setTimeout(function () {
            callback();
            element.remove();
        }, 100);
    }

    function replaceTheme() {
        let browser = kendo.support.browser,
            oldSkinName = $(doc).data("kendoSkin"),
            newLink;

        if (browser.msie && browser.version < 10) {
            newLink = doc.createStyleSheet(newSkinUrl);
        } else {
            newLink = skinLink.eq(0).clone().attr("href", newSkinUrl);
            newLink.insertBefore(skinLink[0]);
        }

        skinLink.remove();

        $(doc.documentElement).removeClass("k-" + oldSkinName).addClass("k-" + skinName);
    }

    if (animate) {
        preloadStylesheet(newSkinUrl, replaceTheme);
    } else {
        replaceTheme();
    }
}

export function currentTheme() {
    return window.localStorage.getItem("nama-k-theme") || 'default';
}

export function changeFontSize(value) {
    value = value || currentFontSize();
    $("body").css("font-size", value);
    window.localStorage.setItem("nama-k-font-size", value)
}

export function changeFontType(value) {
    value = value || currentFontType();
    if (value == "Default")
        value = '\'Almarai\', sans-serif';
    $("body").css("font-family", value);
    $("h1,h2,h3,h4,h5,h6").css("font-family", value);
    window.localStorage.setItem("nama-k-font-type", value)
}

export function currentFontSize() {
    return window.localStorage.getItem("nama-k-font-size") || '14px';
}

export function currentFontType() {
    return window.localStorage.getItem("nama-k-font-type") || '\'Almarai\', sans-serif';
}